<template>
  <div v-click-outside="closeDropdown" style="position: relative">
    <div :class="{ active: buttonActive }" class="dropdown-btn" @click="buttonActive = !buttonActive">
      <div class="text">
        {{ navHeader }}
      </div>
      <i class="mdi mdi-chevron-down"></i>
    </div>
    <div :class="{ active: buttonActive }" class="dropdown-choices">
      <div
        v-for="(navChoice, index) in navChoices"
        :key="index"
        class="choice"
        @click="navChoice.function(navChoice.params)"
      >
        <div>
          {{ navChoice.text }}
        </div>
        <i v-if="navChoice.icon !== null" :class="navChoice.icon"> </i>
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'

export default {
  name: 'dropdown',

  directives: {
    ClickOutside,
  },
  props: {
    navChoices: {
      type: Array,
      default: () => [],
    },
    navHeader: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      buttonActive: false,
    }
  },
  methods: {
    closeDropdown() {
      this.buttonActive = false
    },
  },
}
</script>

<style scoped></style>
